import UAParser from 'ua-parser-js';

const TEST_IMAGES = [
  'https://match-ide.pipacoding.com/2021-06-22/10592713877447995/file',
  'https://img.hetao101.com/hetaomatch/700651427755884544.jpg',
  'https://img.pipacoding.com/hetaomatch/700651427755884544.jpg',
  'https://sb2.hetao101.com/taobao.jpg',
  'https://sb2.pipacoding.com/taobao.jpg',
  'https://cdn.console.pipacoding.com/crm/communication/examineAndApprove/1610700895996_o_1es2k2dnhlv011m31k1t1ps4hpe4o_3.png',
];
const IDE_URL = 'https://match.hetao101.com/contestide/?forwardLoad=1';

export function checkBrowser() {
  const parser = new UAParser();
  const browser = parser.getBrowser();
  const name = browser.name;
  const UA = navigator.userAgent;
  const result = {
    isMobile: false,
    isSogou: false,
    isLianXiang: false,
    isQQBrowser: false,
    isChrome: false,
    chromeVersion: '',
    chromeMajorVersion: '',
    browserName: name,
    browserVersion: browser.version,
  };

  if (parser.getDevice().type == 'mobile') {
    // 检测的设备为手机
    result.isMobile = true;
  } else if (
    name === 'QQ' ||
    name === 'QQBrowser' ||
    name === 'QQBrowserLite'
  ) {
    // 检测为qq浏览器
    result.isQQBrowser = true;
  } else if (/SE 2.X/i.test(UA)) {
    result.isSogou = true;
  } else if (/SLBrowser/i.test(UA)) {
    result.isLianXiang = true;
  } else if (name == 'Chrome') {
    // 检测为谷歌浏览器
    result.isChrome = true;
    result.chromeVersion = browser.version || '';
    result.chromeMajorVersion = browser.version
      ? browser.version.split('.')[0]
      : '';
  }
  return result;
}

// 检查图片是否可以正常加载
function checkImage(imgSrc: string): Promise<[string, boolean]> {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = function () {
      resolve([imgSrc, true]);
    };
    img.onerror = function () {
      resolve([imgSrc, false]);
    };
    img.src = imgSrc;
  });
}

// 默认重试3次
function checkImageRetry(
  imgSrc: string,
  retry = 3
): Promise<[string, boolean]> {
  return checkImage(imgSrc).then(res => {
    if (res && res[1]) return res;
    if (retry <= 0) return res;
    return checkImageRetry(imgSrc, retry - 1);
  });
}

// 检查所有图片是否可以正常加载
// 返回加载失败的图片
export function checkDomainConnection() {
  const checks = TEST_IMAGES.map(img => checkImageRetry(img));
  return Promise.all(checks).then(res => {
    return res
      .filter(item => item && item[1] === false)
      .map(item => item && item[0]);
  });
}

// 预加载ide
export function preloadIDE() {
  return new Promise(resolve => {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('style', 'border:0;visibility:hidden');
    const callback = () => {
      resolve(true);
      document.body.removeChild(iframe);
    };
    iframe.onload = callback;
    iframe.onerror = callback;
    iframe.src = IDE_URL;
    document.body.appendChild(iframe);
  });
}

/**
 * 下载chrome的方法
 *
 * @export
 */
export function downloadChrome() {
  const macUrl = 'https://img.hetao101.com/competition/googlechrome%20.dmg';
  const winUrl = 'https://img.hetao101.com/competition/ChromeSetup.exe';
  let url;

  if (/macintosh|mac os x/i.test(navigator.userAgent)) {
    url = macUrl;
  } else {
    url = winUrl;
  }

  window.open(url);
}

export function downloadImage(src: string, name: string) {
  fetch(src).then(response => {
    response.blob().then(myBlob => {
      const href = URL.createObjectURL(myBlob);
      const a = document.createElement('a');
      a.href = href;
      a.download = name;
      a.click();
    });
  });
}
